import { CFTokens } from '../../../tokens';
export const COLORS = {
    ALTERNATE_CURRENT: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
    ALTERNATE_DEFAULT: CFTokens.COLOR.SALT_40,
    BOOST_CURRENT: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
    BOOST_DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
    CURRENT: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    DEFAULT: CFTokens.COLOR.INK_24,
    DISABLED: CFTokens.COLOR.INTERACTIVE_DISABLED,
    EMPHASIS_CURRENT: CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
    EMPHASIS_DEFAULT: CFTokens.COLOR.PURPLE_4,
};
export const DURATION = 200;
export const GAP = CFTokens.SPACER.B;
export const HEIGHT = 8;
export const WIDTH = {
    DOT: {
        CURRENT: 16,
        DEFAULT: 8,
    },
    PILL: {
        CURRENT: 32,
        DEFAULT: 16,
    },
};
